var _circle, _circle2, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAimKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 265,
    height: 140,
    viewBox: "0 0 265 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 70,
    r: 68,
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 90,
    r: 48,
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 64,
    x2: 60,
    y2: 64,
    stroke: "#F99D27",
    strokeWidth: 12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAimKey);
export default __webpack_public_path__ + "static/media/aim_key.7ef98bf244085d13385ec74102844e19.svg";
export { ForwardRef as ReactComponent };